export default "__VITE_ASSET__CtkadNVI__"